import { useMutation } from '@tanstack/react-query';
import type { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

import { useAxiosConfig } from '#/shared/hooks/useAxiosConfig';
import { useTimesheetStore } from '#/shared/stores/timesheetStore';

import { ForwardRequestApiData } from '../types/ForwardRequestApi';

// TODO: PPL-2240-verify-timesheet-action cleanup - Remove this default url as API will return the correct url
const DEFAULT_FORWARD_URL = '/timesheet-online-approval/forward';

export type ForwardRequestMutationVariables = {
  data: ForwardRequestApiData;
};

export const forwardRequest = async ({
  api,
  url,
  data,
}: { api: AxiosInstance; url: string } & ForwardRequestMutationVariables): Promise<AxiosResponse> => {
  return api.patch(url, data);
};

export const useForwardRequestMutation = () => {
  const api = useAxiosConfig();
  const url = useTimesheetStore(state => state.links?.forward?.href ?? DEFAULT_FORWARD_URL);

  return useMutation<AxiosResponse, AxiosError, ForwardRequestMutationVariables>({
    mutationFn: variables => forwardRequest({ api, url, ...variables }),
  });
};
